export default __webpack_public_path__ + "static/peckshield@2x-4800d754b209d81346aa3b6844ceb85e.jpg";